import styled from "@emotion/styled"
import { css, keyframes } from '@emotion/react'
import facepaint from "facepaint"

import { ReactComponent as OnboardSvg } from 'resources/icons/space/onboard_pt1.svg'

const breakpoints = [440, 768, 1024, 1200, 1400];
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(32px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const OnboardIcon = styled(OnboardSvg)`
  stroke-width: 1.5px;
`

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const tabsMQ = css(mq({
  display: [
    "flex", // 0+
    "flex", // 440+
    "flex", // 768+
  ],
  gap: [
    16,
    12,
    20,
  ],
  "& > button:nth-of-type(3), & > div:nth-of-type(2)": {
    display: [
      "none", // 0+
      "flex", // 440+
      "flex", // 768+
    ],
  }
}))
export const Tabs = styled.div`
  align-items: center;
  ${tabsMQ}
`

const tabActive = ({ isActive }) => {
  if (isActive) {
    return css(mq({
      font: [
        "var(--text-570)", // 0+
        "var(--text-570)", // 440+
        "var(--text-570)", // 768+
        "var(--text-670)", // 1024+
      ],
      color: "var(--color-grayscale-900)",
      borderColor: "var(--color-grayscale-850)",
    }))
  }
}

const tabMQ = css(mq({
  font: [
    "var(--text-540)", // 0+
    "var(--text-540)", // 440+
    "var(--text-540)", // 768+
    "var(--text-640)", // 1024+
  ],
  "& > svg": {
    display: [
      "none", // 0+
      "none", // 440+
      "flex", // 768+
    ]
  }
}))

export const Tab = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--color-grayscale-750);
  padding: 12px 0;
  border-bottom: 4px solid transparent;
  outline: none;
  transition: color var(--fast-transition);

  &:hover {
    color: var(--color-grayscale-950);
  }

  & > svg {
    width: 22px;
    height: 22px;
  }
  ${tabMQ}
  ${tabActive}
`

export const TabDivider = styled.div`
  background: rgba(0, 0, 0, 0.08);
  height: 29px;
  width: 1px;
`

const backgrounds = [
  "//cdn-platform.scope-dev.ws/website/images/backgrounds/grad_p.webp",
  "//cdn-platform.scope-dev.ws/website/images/backgrounds/grad_y.webp",
  "//cdn-platform.scope-dev.ws/website/images/backgrounds/grad_e.webp",
  "//cdn-platform.scope-dev.ws/website/images/backgrounds/grad_r.webp",
  "//cdn-platform.scope-dev.ws/website/images/backgrounds/grad_b.webp",
];

const sectionActive = ({ activeIndex }) => {
  return css({
    backgroundImage: `url(${backgrounds[activeIndex]})`,
  })
}

const screenSectionMQ = css(mq({
  padding: [
    16, // 0+
    16, // 440+
    56, // 768+
    56, // 1024+
    56, // 1200+
    56, // 1400+
  ],
}))

export const ScreenSection = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: calc(100vw / 1.58);
  max-height: 972px;
  overflow: hidden;
  background-position: center;
  ${sectionActive}
  ${screenSectionMQ}
`

const screenWrapMQ = css(mq({
  padding: [
    8, // 0+
    8, // 440+
    12, // 768+
    16, // 1024+
    16, // 1200+
    16, // 1400+
  ],
  borderRadius: [
    8, // 0+
    8, // 440+
    12, // 768+
    16, // 1024+
    16, // 1200+
    16, // 1400+
  ],
}))

export const ScreenWrap = styled.div`
  display: flex;
  background: rgba(255, 255, 255, 0.28);
  opacity: 0;
  animation: ${fadeIn} 0.6s forwards ease;
  ${screenWrapMQ}
`

const screenMQ = css(mq({
  maxWidth: [
    "calc(100vw - 24px - 24px)", // 0+
    "calc(100vw - 24px - 24px)", // 440+
    "calc(100vw - 36px - 36px)", // 768+
    "calc(100vw - 56px - 56px)", // 1024+
    "calc(100vw - 56px - 56px)", // 1200+
    "calc(100vw - 56px - 56px)", // 1400+
  ],
}))

export const Screen = styled.img`
  width: 1360px;
  border-radius: 6px;
  ${screenMQ}
`
